import * as React from 'react';

import CTAContentfulPiece from 'bundles/coursera-plus-landing-page/components/ctaContentful/CTAContentfulPiece';
import type { PropsForContentfulPiece } from 'bundles/coursera-plus-landing-page/components/ctaContentful/CTAContentfulPiece';
import { pieceForPrimaryButton, searchLabel } from 'bundles/coursera-plus-landing-page/contentful/constants';
import { useLandingPageExtended } from 'bundles/coursera-plus-landing-page/contentfulData/useLandingPageData';

import _t from 'i18n!nls/coursera-plus-landing-page';

type Props = Pick<PropsForContentfulPiece, 'ctaLocation' | 'singleBigButton'> & {
  presentation: string;
  rootClassName?: string;
  isFirstCheckoutInHero: boolean;
};

const PrimaryButtonContentful = (props: Props) => {
  const { ctaLocation, singleBigButton, presentation, rootClassName, isFirstCheckoutInHero } = props;
  const landingPageExtended = useLandingPageExtended();
  const { isCourseraPlusOwner, isCourseraLiteOwner } = landingPageExtended;
  const { labelForPrimaryCheckout } = landingPageExtended.landingPage;
  let label = labelForPrimaryCheckout;
  if (isCourseraPlusOwner) {
    label = searchLabel();
  } else if (isCourseraLiteOwner) {
    label = _t('Upgrade to Coursera Plus');
  }

  return (
    <CTAContentfulPiece
      piece={pieceForPrimaryButton(presentation, label, isFirstCheckoutInHero)}
      ctaLocation={ctaLocation}
      singleBigButton={singleBigButton}
      rootClassName={rootClassName}
    />
  );
};

export default PrimaryButtonContentful;
